import { t } from "i18next";

import { messagesDe } from "./de";

// This helper converts "Literal Strings" back to generic "string" while keeping the keys and nested structure exact.
// This is needed to relax the definition for other languages.
export type TranslationSchema<T> = {
  [K in keyof T]: T[K] extends string ? string : TranslationSchema<T[K]>;
};

export type TranslationType = TranslationSchema<typeof messagesDe>;

export type ITranslation = typeof t;

export enum LanguageType {
  de = "de",
}

export type LeafTranslationKeys<T, P extends string = ""> = {
  [K in keyof T & string]: T[K] extends string
    ? P extends ""
      ? K
      : `${P}.${K}`
    : LeafTranslationKeys<T[K], P extends "" ? K : `${P}.${K}`>;
}[keyof T & string];

// Global i18next augmentation: typed t() keys for every program that includes this module — the
// standalone @shared type-check directly, and each app via its translations barrel importing from
// the @shared barrel. Deliberately a regular module (not a .d.ts): ambient declaration files are
// not pulled into the apps' programs through import chains.
declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: {
      // Can't use the TranslationType here, as the relaxed type would block inferring the required parameters
      translation: typeof messagesDe;
    };
  }
}
